import { useCallback, useContext, useMemo } from 'react';
import { useQuery } from '@apollo/client';
import clientAvenyModel from '../../../../../Model/clientAvenyModel';
import { IClientBusinessModel } from '../../../../../Types/ClientModelTypes';
import { BusinessCollectionCompType } from '../../../../../Types/ObjektVy';
import BusinessDataForm from '../../../_Common/Components/BusinessCollectionComponents/BusinessDataForm/BusinessDataForm';
import ObjektVy from '../../../_Common/Components/BusinessCollectionComponents/ObjektVy/ObjektVy';
import { ObjektVyKort } from '../../../_Common/Components/BusinessCollectionComponents/ObjektVyKort/ObjektVyKort';
import ObjektVySida from '../../../_Common/Components/BusinessCollectionComponents/ObjektVySida/ObjektVySida';
import query from './BudgetAskandemallarQuery.gql';
import ObjektVyKolumner, {
  ObjektVyKolumn,
} from '../../../_Common/Components/BusinessCollectionComponents/ObjektVyKolumner/ObjektVyKolumner';
import EDAvenyProgress from '../../../../../BaseComponents/ProgressIndicators/AvenyProgress/EDAvenyProgress';
import {
  arbbudgrader,
  arbbudgrader_rtn_EKArbetsbudgetrader,
} from './_QueryTypes/arbbudgrader';
import { IColumnDef } from '../../../../../Types/ColumnDefType';
import {
  AssociationList,
  IAssociationListConfig,
} from '../../../_Common/Components/BusinessCollectionComponents/AssociationList/AssociationList';
import { IFormData } from '../../../_Common/Components/BusinessCollectionComponents/BusinessDataForm/Utils/BusinessDataFormUtils';
import { GridContext } from '../../../../GridContext';
import { selectedId } from '../../../../../Components/MasterDetail/MasterDetailUtils';
import { ActiveDatabaseContext } from '../../../../../Components/ActiveDatabaseContext/ActiveDatabaseContext';

const ArbetsbudgetRadModel: IClientBusinessModel =
  clientAvenyModel.EK.BusinessModels.EKArbetsbudgetrad;

interface IBudgetAskandemallarData {
  id: string;
  _Associations: {
    Budgetrader:
      | (arbbudgrader_rtn_EKArbetsbudgetrader | null)[]
      | null
      | undefined;
  };
}

export const BudgetAskandemallar: BusinessCollectionCompType = props => {
  const { activeDatabase } = useContext(ActiveDatabaseContext);

  const { loading, data, refetch } = useQuery<arbbudgrader>(query, {
    variables: {
      dbname: activeDatabase ?? '',
      ID: selectedId(props.id),
    },
  });

  const modifiedData: IBudgetAskandemallarData = useMemo(() => {
    return {
      id: selectedId(props.id) ?? '',
      _Associations: { Budgetrader: data?.rtn?.EKArbetsbudgetrader },
    };
  }, [data?.rtn?.EKArbetsbudgetrader, props.id]);

  const customDefaultColumns: IColumnDef[] = useMemo(() => {
    const result: IColumnDef[] = [];

    result.push({ attributeDef: 'Kontostrang' });
    result.push({ attributeDef: 'Kontoben' });
    result.push({ attributeDef: 'DEBET', caption: 'Kostnad' });
    result.push({ attributeDef: 'KREDIT', caption: 'Intäkt' });
    result.push({ attributeDef: 'KOMMENTAR' });
    result.push({
      attributeDef: 'Analyskolumn_1',
      caption: 'Bokfört/Tom Sep-23',
    });
    result.push({ attributeDef: 'Analyskolumn_2', caption: 'Budget/2023' });
    result.push({ attributeDef: 'Analyskolumn_3', caption: 'Bokfört/2022' });

    return result;
  }, []);

  const budgetAskandeMallarConfig: IAssociationListConfig = useMemo(() => {
    return {
      inCard: true,
      integrated: true,
      defaultVisningstyp: 'tabell',
      customDefaultColumns: customDefaultColumns,
    };
  }, [customDefaultColumns]);

  const updateFunction = useCallback((_values: IFormData) => {
    //Logik för vad vi ska skicka tillbaka.

    // console.log('updated data', values);
    return Promise.resolve();
  }, []);

  return (
    <BusinessDataForm<IBudgetAskandemallarData>
      isEditing={true}
      data={modifiedData}
      dataLoading={loading}
      fullScreen={props.config?.fullPage ?? false}
      isNew={props.isNew}
      model={ArbetsbudgetRadModel}
      validateFns={[]}
      refetchData={refetch}
      updateMutation={updateFunction}
    >
      {loading && <EDAvenyProgress />}
      <ObjektVy nodeLoading={loading} editImplemented sideBySideWidths={[6, 6]}>
        <ObjektVySida
          caption="ÄskandeMallar"
          collectionName={ArbetsbudgetRadModel.CollectionName}
          sidNr={1}
        >
          <ObjektVyKolumner>
            <ObjektVyKolumn fullPage={false}>
              <ObjektVyKort caption="Arbetsbudget rader">
                <GridContext.Provider value={{ inGrid: true }}>
                  <AssociationList
                    associationName="Budgetrader"
                    associationPath="Budgetrader"
                    collectionName="EKArbetsbudget"
                    ownId={selectedId(props.id)}
                    config={budgetAskandeMallarConfig}
                  />
                </GridContext.Provider>
              </ObjektVyKort>
            </ObjektVyKolumn>
          </ObjektVyKolumner>
        </ObjektVySida>
      </ObjektVy>
    </BusinessDataForm>
  );
};
